import { render, staticRenderFns } from "./PreAreaList.vue?vue&type=template&id=c7791e6a&scoped=true&"
import script from "./PreAreaList.vue?vue&type=script&lang=js&"
export * from "./PreAreaList.vue?vue&type=script&lang=js&"
import style0 from "./PreAreaList.vue?vue&type=style&index=0&id=c7791e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7791e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7791e6a')) {
      api.createRecord('c7791e6a', component.options)
    } else {
      api.reload('c7791e6a', component.options)
    }
    module.hot.accept("./PreAreaList.vue?vue&type=template&id=c7791e6a&scoped=true&", function () {
      api.rerender('c7791e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/PreAreaList.vue"
export default component.exports